export const SUCCESSFUL_GET_SALEORDERS_SIGNEDCONTRACT  = "SUCCESSFUL_GET_SALEORDERS_SIGNEDCONTRACT";
export const SUCCESSFUL_GET_SALEORDERS_PAYABLE  = "SUCCESSFUL_GET_SALEORDERS_PAYABLE";
export const SUCCESSFUL_GET_SALEORDERS_WITH_PAYMENTS  = "SUCCESSFUL_GET_SALEORDERS_WITH_PAYMENTS";
export const SUCCESSFUL_GET_STATUS_SALEORDER_IN_PROGRESS  = "SUCCESSFUL_GET_SALEORDER_IN_PROGRESS";


// WEBPACK FOOTER //
// ./src/reducers/saleorders/actionConst.js